import { IMarketingCenterTemplate } from '@/models/marketingCenter/template';
import {
  TitleCanvasElement,
  BackgroundImageCanvasElement,
  TextCanvasElement,
  BrandCanvasElement
} from '@/models/marketingCenter/elements';
import {
  InstagramPostFormat,
  InstagramStoryFormat,
  FacebookPostFormat
} from '@/models/marketingCenter/formats';
import { EMarketingCenterColorSchemes } from '../colorScheme';

const BirthdayTemplate: IMarketingCenterTemplate = {
  tag: 'Offers',
  title: 'Birthday Offer Post',
  description:
    'Show your customers that they can redeem some special discount the week of their birthday.',
  disabledDescription:
    'To create a Birthday Offer Post, first you will need to create a Birthday Offer.',
  button: {
    label: 'Create a Birthday Offer',
    link: '/special-coins-offers/create'
  },
  placeholders: {
    title: 'Come in and enjoy a free dessert on us for your birthday!',
    text: 'Get offer!',
    colorScheme: EMarketingCenterColorSchemes.AQUAMARINE,
    titleMaxLength: 68
  },
  form: {
    hideMessageField: true,
    textFieldAsTextArea: true
  },
  formats: [
    new InstagramStoryFormat([
      new BackgroundImageCanvasElement({
        image: 'marketingCenter/canvas/birthday/instagram-story.png'
      }),
      new BrandCanvasElement({
        width: 60,
        height: 60,
        x: 155,
        y: 189,
        radius: 30,
        borderWidth: 2
      }),
      new TextCanvasElement({
        font: {
          size: 10,
          weight: 'bold',
          lineHeight: 11,
          numberOfLines: 1,
          maxWidth: 118
        },
        position: {
          x: 33,
          y: 225
        },
        text: args => args.business.name
      }),
      new TitleCanvasElement({
        font: {
          size: 23,
          weight: 'bold',
          lineHeight: 25,
          maxWidth: 197,
          numberOfLines: 6
        },
        position: {
          x: 33,
          y: 255
        }
      })
    ]),
    new InstagramPostFormat([
      new BackgroundImageCanvasElement({
        image: 'marketingCenter/canvas/birthday/instagram-post.png'
      }),
      new BrandCanvasElement({
        width: 60,
        height: 60,
        x: 155,
        y: 131,
        radius: 30,
        borderWidth: 2
      }),
      new TextCanvasElement({
        font: {
          size: 12,
          weight: 'bold',
          lineHeight: 12,
          numberOfLines: 1,
          maxWidth: 118
        },
        position: {
          x: 33,
          y: 167
        },
        text: args => args.business.name
      }),
      new TitleCanvasElement({
        font: {
          size: 12,
          weight: 'bold',
          lineHeight: 14,
          maxWidth: 173,
          numberOfLines: 3
        },
        position: {
          x: 33,
          y: 191
        }
      })
    ]),
    new FacebookPostFormat([
      new BackgroundImageCanvasElement({
        image: 'marketingCenter/canvas/birthday/facebook-post.png'
      }),
      new BrandCanvasElement({
        width: 40,
        height: 40,
        x: 27,
        y: 84,
        radius: 20,
        borderWidth: 2
      }),
      new TextCanvasElement({
        font: {
          size: 7,
          weight: 'bold',
          lineHeight: 8,
          numberOfLines: 1,
          maxWidth: 118
        },
        position: {
          x: 73,
          y: 109
        },
        text: args => args.business.name
      }),
      new TitleCanvasElement({
        font: {
          size: 10,
          weight: 'bold',
          lineHeight: 13,
          maxWidth: 78,
          numberOfLines: 6
        },
        position: {
          x: 164,
          y: 29
        }
      })
    ])
  ]
};

export default BirthdayTemplate;
